import {format, parse, isValid} from 'date-fns';
import {ptBR} from 'date-fns/locale';

type Separator = 'às' | '-';

export function formatDateString(
	dateString: string,
	inputFormat: string,
	outputFormat: string,
	separator?: Separator,
) {
	if (!dateString) {
		return '';
	}

	const parsedDate = parse(dateString, inputFormat, new Date(), {locale: ptBR});

	if (!isValid(parsedDate)) {
		return dateString;
	}

	const formattedDate = format(parsedDate, outputFormat, {locale: ptBR});

	if (separator) {
		const [date, time] = formattedDate.split(' ');
		return `${date} ${separator} ${time}`;
	}

	return formattedDate;
}

export function formatMonth(monthYear: string): string {
	return formatDateString(monthYear, 'MMMM/yyyy', 'MMM/yyyy');
}
